import { render, staticRenderFns } from "./MemoPreview.vue?vue&type=template&id=345fc818&lang=pug&"
import script from "./MemoPreview.vue?vue&type=script&lang=js&"
export * from "./MemoPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports